import { Filter } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/v2/button";
import SearchInput from "@/components/ui/v2/search-input";

interface TableToolbarProps {
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  onFiltersClick?: () => void;
  filtersLabel?: string;
  actions?: React.ReactNode;
  searchValue?: string;
  /** When false, search input is hidden. Default true when onSearchChange is provided. */
  showSearch?: boolean;
}

export function TableToolbar({
  onSearchChange,
  searchPlaceholder,
  onFiltersClick,
  filtersLabel,
  actions,
  searchValue,
  showSearch = true,
}: TableToolbarProps) {
  const { t } = useTranslation();
  const showSearchInput = showSearch && onSearchChange != null;

  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div className="flex flex-1 flex-col gap-4 sm:flex-row sm:items-center">
        {showSearchInput && (
          <div className="flex-1 max-w-md">
            <SearchInput
              placeholder={searchPlaceholder ?? t("common.search")}
              onChange={(e) => onSearchChange(e.target.value)}
              value={searchValue ?? ""}
            />
          </div>
        )}
        {onFiltersClick && (
          <Button
            variant="outline"
            onClick={onFiltersClick}
            className="w-full sm:w-auto"
          >
            <Filter className="h-4 w-4" />
            {filtersLabel ?? t("common.filters")}
          </Button>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
